import React, { FC } from 'react';

import { EvFiltersPanel, IEvFiltersPanelProps } from '@evinced-private/ui-common';

import { useFiltersPanelOverflowModal } from './useFiltersPanelOverflowModal';

import './ProductFiltersPanel.scss';

export const ProductFiltersPanel: FC<IEvFiltersPanelProps> = ({
	filterDefinitions,
	initialValues,
	onApply,
	...props
}) => {
	const appliedValues = initialValues ?? {};

	const { showMoreChipsProps, overflowModal } = useFiltersPanelOverflowModal({
		panelDefinitions: filterDefinitions,
		appliedValues,
		onApply
	});

	return (
		<>
			<EvFiltersPanel
				{...props}
				filterDefinitions={filterDefinitions}
				initialValues={initialValues}
				onApply={onApply}
				showMoreChipsProps={showMoreChipsProps}
			/>
			{overflowModal}
		</>
	);
};
